import { OfflineDatabaseKit } from '../../../../../../../../database/offlineDatabase/types/offlineDatabaseKit.types';

export const mapKitEntitiesIds = (kits: OfflineDatabaseKit[]) => {
  const { productColorIdsSet, productIdsSet, skuIdsSet, kitWithRelationsMap } = kits.reduce(
    (acc, kit) => {
      const pcIdsSet = new Set<string>();
      const pIdsSet = new Set<string>();
      const sIdsSet = new Set<string>();

      for (const sk of kit.skuKits) {
        const pcId = sk.productColor.id;
        const pId = sk.product.id;
        const sId = sk.sku.id;

        acc.productColorIdsSet.add(pcId);
        acc.productIdsSet.add(pId);
        acc.skuIdsSet.add(sId);

        pcIdsSet.add(pcId);
        pIdsSet.add(pId);
        sIdsSet.add(sId);
      }

      acc.kitWithRelationsMap.set(kit.id, {
        productColorIds: [...pcIdsSet],
        productIds: [...pIdsSet],
        skuIds: [...sIdsSet],
      });

      return acc;
    },
    {
      productColorIdsSet: new Set<string>(),
      productIdsSet: new Set<string>(),
      skuIdsSet: new Set<string>(),
      kitWithRelationsMap: new Map<
        string,
        { productColorIds: string[]; productIds: string[]; skuIds: string[] }
      >(),
    },
  );

  const productColorIds = [...productColorIdsSet];
  const productIds = [...productIdsSet];
  const skuIds = [...skuIdsSet];

  return { productColorIds, productIds, skuIds, kitWithRelationsMap };
};
